import type { FaireProductEntity } from "../../entity_types/product";

export const p_jvanxddeqg: FaireProductEntity = {
  token: "p_jvanxddeqg",
  type: "product",
  name: "Ceramic Trinket Tray, Scandinavian Icons",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/dc4a6063f46025ff8ff6df89d3b679d95bef52eac81f86d8d15fad76166495b9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f28ed76cf6c60018e509b8645b7596864c1e7b1542da23270c8cb1bad4b59c48.jpeg"
  ],
  priceDollars: 9.5,
  description: "Cozy meets convenience! This adorable ceramic trinket tray features all your favorite Scandinavian icons, with a  scalloped edge to keep all your bobbles home sweet home. \n\nProduct Details: \nDimensions: 7.5 in. x 4.5 in.\nCeramic\n\nKey Features:\nScandinavian inspired icon artwork brings cheerful personality to everyday spaces\nCeramic construction offers a classic, decorative finish\nScalloped edge adds a charming vintage-inspired detail\nVersatile catchall tray for jewelry, keys, coins, hair accessories, and small treasures\nCompact decorative footprint works beautifully on nightstands, desks, dressers, and entryway tables\nFunctional and giftable design makes organization feel fun\nPlayful ban.do aesthetic combines cozy style with practical everyday function\nEasy retail add-on for gift, home décor, and lifestyle collections\n\nIdeal for:\nGift shops and lifestyle boutiques\nHome décor and accessory retailers\nIndependent bookstores and curated lifestyle shops\nMuseum and design-focused gift stores\nScandinavian and Nordic-inspired retailers\nJewelry and fashion accessory boutiques\nHousewarming and hostess gift shops\nStationery and desk accessory stores\nRetailers seeking affordable stocking stuffers and small gifts\nColorful, design-forward concept shops",
  tags: [],
  msrpDollars: 19.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:19.252Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
